import React, { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from 'styled-components';
import { Text, Button } from '../../mo-gel';
import {
  StyledMainContainer,
  StyledMainHeading,
  StyledContentMainContainer,
  StyledContentContainer,
  StyledContentHeading,
  StyledImage,
  StyledContent,
  StyledButtonContents,
  StyledIconContainer,
  StyledChevron
} from './WhoIsThisFor.styled';
import { ReactComponent as RightArrow } from '../../images/icons/right_icon.svg';

interface SlideItem {
  image: string;
  title: string;
  text: string;
  link: string;
}

interface WhoIsThisForProps {
  slides: SlideItem[];
}

export const WhoIsThisFor = ({ slides }: WhoIsThisForProps) => {
  const [marginLeft, setMarginLeft] = useState(0);
  const navigate = useNavigate();
  const theme = useTheme();

  const handleClick = useCallback((value: number) => {
    setMarginLeft((current) => {
      let newMargin = 0;

      if (current === -200 && value === -100) {
        newMargin = 0;
      } else if (current === 0 && value === 100) {
        newMargin = -200;
      } else {
        newMargin = current + value;
      }

      return newMargin;
    });
  }, []);

  const renderSlides = useCallback(
    () =>
      slides.map((slide: SlideItem, index: number) => (
        <StyledContentContainer key={index}>
          <StyledImage $image={slide.image} />
          <StyledContent>
            <StyledContentHeading level="h5" align="center" marginTop="0" color={theme.colors.content}>
              {slide.title}
            </StyledContentHeading>
            <Text tag="p" level="normal" marginBottom="0" color={theme.colors.content}>
              {slide.text}
            </Text>
          </StyledContent>
          <Button primary={true} width="194px" onClick={() => navigate(slide.link)}>
            <StyledButtonContents>
              Find out more <RightArrow />
            </StyledButtonContents>
          </Button>
        </StyledContentContainer>
      )),
    [navigate, slides, theme.colors.content]
  );

  return (
    <StyledMainContainer id="whositfor">
      <StyledMainHeading level="h4" align="center" marginTop="0" width="100%" color={theme.colors.content}>
        WHO IS THIS FOR?
      </StyledMainHeading>
      <StyledContentMainContainer $marginLeft={marginLeft}>{renderSlides()}</StyledContentMainContainer>
      <StyledIconContainer>
        <StyledChevron content="'<'" onClick={() => handleClick(100)} />
        <StyledChevron content="'>'" onClick={() => handleClick(-100)} />
      </StyledIconContainer>
    </StyledMainContainer>
  );
};
